import { Route } from '@angular/router';
import { RouteGuard } from '../auth/route.guard';

const restaurantItemRoutes: Route[] = [
  {
    path: 'restaurantitem',
    loadChildren: () =>
      import('./restaurant-item/restaurant-item.module').then(
        (m) => m.RestaurantItemModule,
      ),
    canActivate: [RouteGuard],
  },
];

export default restaurantItemRoutes;
